import { type LegacyReferralMessageViewModel } from '@generated';
import { DataTable } from '~/shared/data-tables/DataTable';
import { StatusPill } from '~/shared/StatusPill';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';
import { formatToShortDateAndTimeOrNull } from '~/util/date';
import { getMessageStatusIntent, getMessageStatusLabel, getMessageTypeLabel } from '../referralHelpers';

const columns: DataTableColumnProps<LegacyReferralMessageViewModel>[] = [
	{
		header: 'Created',
		key: 'dateCreated',
		renderCell: x => formatToShortDateAndTimeOrNull(x.dateCreated)
	},
	{
		header: 'Sent',
		key: 'sentOn',
		renderCell: x => formatToShortDateAndTimeOrNull(x.sentOn, '-')
	},
	{
		header: 'Type',
		key: 'messageTypeId',
		renderCell: x => getMessageTypeLabel(x.messageTypeId)
	},
	{
		header: 'Recipient',
		key: 'userFullName',
		renderCell: x => (
			<div className="flex flex-col">
				<span>{x.userFullName}</span>
				<span className="text-xs text-gray-500">{x.userEmailAddress}</span>
			</div>
		)
	},
	{
		header: 'Status',
		key: 'statusId',
		renderCell: x => <StatusPill intent={getMessageStatusIntent(x.statusId)}>{getMessageStatusLabel(x.statusId)}</StatusPill>
	},
	{
		header: 'Error',
		key: 'errorMessage',
		renderCell: x => (x.errorMessage ? <span className="text-xs text-red-700">{x.errorMessage}</span> : null)
	}
];

export function LegacyReferralMessagesTable({ rows }: { rows: LegacyReferralMessageViewModel[] }) {
	const sorted = [...rows].sort((x, y) => new Date(y.dateCreated).getTime() - new Date(x.dateCreated).getTime());
	return <DataTable columns={columns} rows={sorted} />;
}
